import React, { useState } from "react";
//#region types
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { FormFieldProps } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import ReadOnlyField from "../baseFields/readOnlyField";
import ChoiceChips from "components/common/selection/choiceSelection";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { FormHelper, LocalizationHelperInstance } from "utils/helpers";

function BooleanSelectionFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const { name, field, value, handleOnChangeCustom, readonly, disabled } = props;

  React.useImperativeHandle(props.fieldRef, () => ({
    change: (selectedItem?: SelectionItem) => {
      onChangeHandler(selectedItem);
    },
  }));

  const valueAll = 3;

  const items = [
    ...FormHelper.getBooleanSelectionItems(),
    { id: valueAll, value: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.All) },
  ];

  const [selectedItem, setSelectedItem] = useState<SelectionItem | undefined>(
    // eslint-disable-next-line eqeqeq --- disabling to avoid regression testing if changed
    items?.find((x) => x.id == (value ?? valueAll))
  );

  const onChangeHandler = (selectedItem?: SelectionItem) => {
    setSelectedItem(selectedItem);
    const value =
      selectedItem === undefined || selectedItem.id === valueAll ? undefined : Boolean(selectedItem.id as number);
    handleOnChangeCustom(name, value, true);
  };

  return readonly ? (
    <ReadOnlyField label={field.label} href={field.href} className={cssExports.readOnlyTextField}>
      {selectedItem?.value ?? ""}
    </ReadOnlyField>
  ) : (
    <ChoiceChips
      title={props.field.label}
      items={items}
      value={selectedItem}
      onChange={onChangeHandler}
      disabled={disabled}
      isReadOnly={readonly}
      className={field.classes?.input}
    />
  );
}

export default BooleanSelectionFormField;
